import axios from "axios";

const API = axios.create({ baseURL: "https://api.scoriva.net/api" });

export const contactApi = {
  // public (Contact səhifəsi)
  create: (payload) => API.post("/contact", payload),

  // admin
  list: () => API.get("/contact"),
  get: (id) => API.get(`/contact/${id}`),
  setRead: (id, isRead) => API.patch(`/contact/${id}/read`, { isRead }),
  remove: (id) => API.delete(`/contact/${id}`),
};
